import React from 'react'
import {
  Dropdown as SemanticDropdown,
  DropdownProps as SemanticDropdownProps,
} from 'semantic-ui-react'
import type { AutomationTarget } from '../../../types'

export interface DropdownProps
  extends SemanticDropdownProps,
    AutomationTarget {}

/**
 * Wraps Semantic UI Dropdown to handle `elmId` → `data-elm-id` mapping,
 * preventing React "unrecognized prop" warnings on DOM elements.
 * Forwards refs so class-component consumers can access .focus(), .inputRef, etc.
 */
const Dropdown = React.forwardRef<any, DropdownProps>(
  ({ elmId, ...rest }, ref) => {
    return <SemanticDropdown ref={ref} data-elm-id={elmId} {...rest} />
  }
)

Dropdown.displayName = 'Dropdown'

// Preserve Semantic UI Dropdown statics (Header, Item, Menu, Divider, etc.)
Object.assign(Dropdown, SemanticDropdown)

export default Dropdown as unknown as typeof SemanticDropdown
